export default __webpack_public_path__ + "static/media/kitchen3-before3-1920w.0fc10f51.webp";